<template>
  <v-card>
    <v-data-table
      :page.sync="page"
      @page-count="pageCount = $event"
      :items="tutor_groups"
      :headers="headers"
      hide-default-footer
    >
      <template v-slot:item.srno="{ item }">
        <span class="table-tutor-srno">{{ item.srno }}</span>
      </template>

      <template v-slot:item.session_link="{ item }">
        <a :href="item.session_link" class="table-tutor-name" target="_blank">{{
          item.session_link
        }}</a>
      </template>

      <template v-slot:item.date="{ item }">
        <span class="table-tutor-date">{{ item.date }}</span>
      </template>

      <template v-slot:item.session="{ item }">
        <span class="table-tutor-session">{{ item.session }}</span>
      </template>

      <template v-slot:item.session_type="{ item }">
        <span class="table-tutor-session">{{ (item.session_type == 'online') ? 'Online' : 'In Center' }}</span>
      </template>

      <template v-slot:item.students="{ item }">
        <span
          v-for="(student, index) in item.group.group_student"
          :key="index"
          class="table-tutor-students"
          >{{ student.student.std_fname }} {{ student.student.std_lname }}</span
        >
        <!-- {{item.group.grou}} -->
      </template>

      <template v-slot:item.session_link="{ item }">
        <a
          v-if="item.class_link != 'nil'"
          @click="markAttendance(item)"
          :href="item.class_link"
          target="_blank"
          color="#E41B1BF7"
          elevation="1"
          dark
          small
        >
          <v-icon dense class="mr-2"></v-icon>Join
        </a>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span :style="{ color: this.$vuetify.theme.themes.light.primary }">{{
          students.length
        }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "PastClassesTable",
  data() {
    return {
      tutor_groups: [],
      dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        { text: "SrNo.", sortable: true, value: "group_session_id" },
        // { text: "Class", value: "group.class.class_name", sortable: true },
        // { text: "Subject", value: "group.subject.subject_name", sortable: true },
        { text: "Student Name", value: "students", sortable: true },
        { text: "Date", value: "session_date", sortable: true },
        { text: "Start Time", value: "session_start_time", sortable: false },
        { text: "End Time", value: "session_end_time", sortable: false },
        // { text: "Session Link", value: "session_link", sortable: false },
        { text: "Class Work", value: "class_work", sortable: false },
        { text: "Session Type", value: "session_type", sortable: false },
      ],
      students: [
        {
          srno: this.getZeroAddedNum(1),
          class: "7th",
          subjects: "Science",
          students: [
            "Ahmad Fraz,",
            "Shumaila razzaq,",
            " Firdoos awan,",
            " Sohaib rana,",
            " Ikram Rana",
          ],
          date: "19-June-2020",
          session: "101",
          session_link: "https://www.youtube.com/watch?v=Xa64aCcc9nA",
          class_work: "link_to_pdf",
        },
      ],
    };
  },
  methods: {
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    markAttendance(item) {
      var user = localStorage.getItem("user");
      item["user"] = JSON.parse(user);
      axios.post("mark/attendance", item).then((response) => {
        console.log(response);
        // this.loading = false
        // this.students = response.data
      });
    },
    getTutorGroups() {
      let user = JSON.parse(localStorage.getItem("user"));
      let tutor_id = user;
      // console.log(tutor_id.id)
      axios.get("tutor/groups/" + user.id + "/past", {}).then((response) => {
        // console.log(response.data)
        this.tutor_groups = response.data;
      });
    },
  },
  mounted() {
    // alert('ss')
    this.getTutorGroups();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}
.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }
  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }
  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }
  &-date {
    font: 500 13px/13px Gotham;
    color: #0ebddff7;
  }
  &-students {
    display: block;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>
